export default {
  patients: {
    label: 'Pacientes',
    viewPatients: 'Ver pacientes',
    viewPatient: 'Ver pacientes',
    editPatient: 'Editar paciente',
    newPatient: 'Nuevo paciente',
  },
}
